/*
 * GRAVURZEILE 23.09.2026 - Produktgalerie der App teeinblue: Vorschaubilder
 * am Handy wischbar.
 *
 * teeinblue verschiebt die Leiste unter dem Hauptbild nur ueber die beiden
 * Pfeile (transform auf .tee-thumbnails__track), Wischen tut dort nichts.
 * Auf Touch-Geraeten setzt dieses Skript die Klasse gz-touch-galerie an <html>;
 * damit macht mf-einheit.css die Leiste zu einer normal scrollbaren Reihe.
 * Pfeile, Antippen und Wischen im Hauptbild bleiben unveraendert bei
 * teeinblue. Wechselt dadurch das aktive Bild, holt das Skript das aktive
 * Vorschaubild in den sichtbaren Bereich.
 * Ohne teeinblue-Galerie auf der Seite passiert nichts.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  var leisten = document.getElementsByClassName('tee-thumbnails__track');
  var beobachtet = [];
  var geplant = false;

  function zeigeAktives(leiste, sanft) {
    var aktiv = leiste.querySelector('.tee-thumbnail--active');
    if (!aktiv || leiste.scrollWidth <= leiste.clientWidth) return;
    var l = leiste.getBoundingClientRect();
    var a = aktiv.getBoundingClientRect();
    var ziel = leiste.scrollLeft;
    if (a.left < l.left) ziel += a.left - l.left;
    else if (a.right > l.right) ziel += a.right - l.right;
    else return;
    try {
      leiste.scrollTo({ left: ziel, behavior: sanft ? 'smooth' : 'auto' });
    } catch (e) {
      leiste.scrollLeft = ziel;
    }
  }

  function einrichten() {
    geplant = false;
    if (!leisten.length) return;
    document.documentElement.classList.add('gz-touch-galerie');
    for (var i = 0; i < leisten.length; i++) {
      var leiste = leisten[i];
      if (beobachtet.indexOf(leiste) !== -1) continue;
      beobachtet.push(leiste);
      zeigeAktives(leiste, false);
      (function (lst) {
        new MutationObserver(function () { zeigeAktives(lst, true); })
          .observe(lst, { subtree: true, attributes: true, attributeFilter: ['class'] });
      })(leiste);
    }
  }

  function planen() {
    if (geplant) return;
    geplant = true;
    (window.requestAnimationFrame || setTimeout)(einrichten);
  }

  /* teeinblue baut die Galerie erst nach dem Laden auf und bei einem
     Variantenwechsel neu - deshalb auf neue Leisten achten. */
  function start() {
    einrichten();
    new MutationObserver(planen).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
